<!-- 组件说明 -->
<!--首页的主页列表--> 
<template>
  <div class="index_wrapper"  style="margin-top:50px">
    <div v-if="indexImgs">
      <van-swipe :autoplay="3000" indicator-color="white" style="width:100%">
        <van-swipe-item v-for="(image, index) in images" :key="index" >
          <!-- <img :v-lazy="image" /> -->
          <img  :src="image.imgUrl + process" alt="">
        </van-swipe-item>
      </van-swipe>
    </div>
    <div v-for="(item,index) in categoryList" :key="index" >
      <div v-if="item.parentId ==0">
      <!-- <div> -->
        <div  style="font-size:20px;text-align:center;padding:10px" >
        <!-- <img src="https://shoplineimg.com/5d38fc60f7124400016c5eb4/5e609bde15a18300240789a0/800x.webp?source_format=jpg" style="width:100%" alt=""> -->
        <img :src="item.pic + process" alt=" "  style="width:100%" >
      </div>
      <!-- <indexItem  :datas='[{categoryId:item.categoryId,shopId:item.shopId}]'/> -->
      <indexItem  :datas='categoryList[index]'/>
      </div>
    </div>
    <!-- 站点 -->
    <div class="sites">
        <span v-for="(item,index) in siteList" :key="index" @click="toDetail(item.id,item.region)">
          {{item.title}}
          <span v-show="index<(siteList.length-1)" >|</span>
        </span>
      </div>
    <!-- <div class="loading" v-if="!shopId">
        <van-loading color="#1989fa" />
    </div>
    <div class="content">
      <div v-if="active==0">
        <view-port @toSearch="toSearch"></view-port>
      </div> -->
      <!-- <div v-if="active==1"> -->
        <!-- <goods-list></goods-list> -->
        <!-- <goods-category ref="category"></goods-category>
      </div> -->
    <!-- </div> -->

    <!-- <van-tabbar  v-model="active" active-color="#ee0a24">
      <van-tabbar-item icon="wap-home">{{$t('index.index')}}</van-tabbar-item> -->
      <!-- <van-tabbar-item icon="goods-collect">列表</van-tabbar-item> -->
      <!-- <van-tabbar-item icon="goods-collect" @click="toList()">{{$t('index.list')}}</van-tabbar-item>
    </van-tabbar> -->
    
  </div>
</template>

<script>
import { Swipe, SwipeItem,Pagination, List   } from 'vant';
import ViewPort from './index/common/ViewPort';
import GoodsList from './GoodsList';
import home from "@/api/home";
import goods from "@/api/goods";
import GoodsCategory from './GoodsCategory';
import indexItem from './index/index2';
export default {
  components: { ViewPort, GoodsList,GoodsCategory ,indexItem},
  data() {
    return {
      active: 0,
      images: [
        'https://shoplineimg.com/5d38fc60f7124400016c5eb4/5e609bde15a18300240789a0/800x.webp?source_format=jpg',
        'https://shoplineimg.com/5d38fc60f7124400016c5eb4/5e609c4dfe946f00121e1d07/800x.webp?source_format=jpg'
      ],
      categoryList:[],
      currentPage: null,
      pagination:[],
      pageIndex:[],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      listItem:[],
      siteList:[],
      indexImgs:false
      // loading:false
    };
  },
  computed: {
    // shopId: {
    //   get() {
    //     sessionStorage.setItem("shopId",this.$store.state.designer.shopId);
    //     return this.$store.state.designer.shopId;
    //   },
    // },
  },
  methods: {
    init(region,shopId){
      this.getcategoryInfo(shopId,region)//分类
      this.getSiteList(shopId,region)//站点
      this.getIndexImg(shopId,region)//轮播
    },
    getSiteList(shopId,region) {
      //获取站点列表
      goods.topSiteList({ shopId:shopId||sessionStorage.getItem('shopId'), region: region||sessionStorage.getItem('REG')}).then((res) => {
        this.siteList = res;
      });
    },
    // 首页轮播图
    getIndexImg(shopId,region){
      let params = {
        shopId:shopId,
        region:region
      }
      goods.indexImgs(params).then((res) => {
        this.images =res
        if(this.images.length == 0){
          this.indexImgs = false
        }else{
          this.indexImgs = true
        }
      })
    },
    onChange(e) {},
    toSearch(val){
      // this.active=1
      // this.$nextTick(() => {
      //   this.$refs.category.onSearch(val)
      // })
      this.$router.push({ name: 'GoodsCategory', params: { searchValue: val} })
      
      //  this.$refs.getSearch.toGetSearch(val); 
    },
    toList(){
      this.$router.push('GoodsCategory')
    },
    getshodId(){
    let url = location.host.split('/')[0]
    // 获取shopId
      home.region(url).then(res => {
        this.getIndexImg(sessionStorage.getItem('shopId')||res.shopId,sessionStorage.getItem('REG')||res.region)//轮播
        this.getcategoryInfo(sessionStorage.getItem('shopId'),sessionStorage.getItem('REG'))//分类
        this.shopId = res.shopId
        this.region =res.region
        this.getSiteList(sessionStorage.getItem('shopId')||res.shopId,sessionStorage.getItem('REG')||res.region)
      })
    },
     getcategoryInfo(shopId,region){
      //  获取分类列表 
        goods.categoryInfo({shopId,region}).then(res => {
        let itemList = []
        res.forEach((item,index)=>{
          if(item.parentId === 0){
            itemList.push(item)
          }
        }) 
        this.categoryList = itemList.slice(0,3)
      })
    },
    toDetail(id,region) {
      //点击站点去到相对应的页面
      this.$router.push({ name: "siteDetail", params: { id: id ,region: region} }); 
    },
  },
  created() {
    // 生命周期 - 创建完成
    let clientWidth = document.documentElement.clientWidth + 250;
    this.clientWidth = clientWidth;
    this.process = "?x-oss-process=image/resize,w_" + clientWidth;

    this.getshodId()
     let shopIds = sessionStorage.getItem("shopId") || this.$store.state.user.regionData.shopId;
    //  this.$Fbq.getFbqId('',shopIds)
     sessionStorage.setItem("indexStatus","1");
    //  this.getSiteList()
     
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped='scoped'>
.content {
  padding-bottom: 60px;
}
.loading{
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center; 
    align-items: center;
}
.van-swipe{
  min-height: 175px;
  // height: 500px;
  max-height: 374;
}
.listItem{
  display: flex;
  flex-wrap: wrap;
}
.listItem .listItems{
  width:50%;
}
.item_img{
  // width: 150px;
  // height: 150px;
  // padding: 20px;
        min-width: 150px;
    min-height: 150px;
    padding: 20px;
    /* max-width: 300px; */
    // height: 300px;
}
@media screen and (max-width:768px){
.van-swipe{
  height: 175px;
}
.item_img{
  width: 150px;
  height: 150px;
  padding: 20px 15px;
}
}

.sites {
  margin: 30px 0;
  text-align: center;
  padding: 0 30px;
  font-size: 12px;
  // font-family: 'Medium';
  display: block;
  // font-family: 'Bold';
}
.sites span {
  padding: 5px 0;
}

.van-pagination__item--active{
  background: red!important
}
.pagination .van-pagination ul li {
  color:red!important
}
.van-pagination__item .van-pagination__item--active .van-pagination__page .van-hairline{
  color:red!important;
  background: red!important
}

</style>


// WEBPACK FOOTER //
// src/pages/Index.vue